import React from 'react';
import { History } from 'history';
import { GridContainer, Input, InputEmail, InputFile } from '../../components';
import BaseEdit from '../base/base-edit.component'; 
import Model from './user-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowMedia: any;
}

export default class UserAuthManageUser extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowMedia: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    private onLoadFile = (data: any) => {
        this.setState({datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow: {id: this.state.datarow.imageId, files: data, ref: Model.endPointMedia, field:'image'}}});
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        var email = this.state.datarow.email;
        if (fieldName === 'useremail' && value) email = Model.getEmailApp(value);

        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value, email: email,
            }
        }
        this.setState(nextState);
    }


    render() {
        return (
            //editable..
            <BaseEdit history={this.props.history} id={+Model.getUser()} caption='Manage User'
                model={Model} datarow={this.state.datarow} datarowMedia={this.state.datarowMedia} onLoad={this.onLoad} onError={this.onError} disableAutoBack>                                    
                <GridContainer align='left'>
                    <InputFile name='imageUrl' label=' ' value={this.state.datarow.imageUrl} type='image' onLoad={this.onLoadFile} error={this.state.errors?.image} onChange={this.onChange} />
                    <GridContainer sx={{display: 'block', ml: 2}}>
                        <Input name='name' label='User Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                        <InputEmail name='useremail' label='User Id' value={this.state.datarow.useremail} readOnly/>
                    </GridContainer>
                </GridContainer>
            </BaseEdit>
        );
    }
}